import React from 'react';
import styled from 'react-emotion';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import qs from 'qs';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.2rem;
  width: 2.2rem;
  margin: 0 0.25rem;
  font-weight: bold;
  font-size: 0.85rem;

  color: #333;
  background: #efefef;
  border: 1px solid #dfdfdf;

  &:hover {
    background: #dadada;
  }
`;

const handleClick = (e, goToPage, page) => {
  e.preventDefault();
  e.target.blur();
  goToPage(page);
};

const PageLink = ({ location, page, goToPage, isCurrent }) => {
  const { queryParam } = React.useContext(PaginationContext);
  const currentLocation = qs.parse(location.search, {
    ignoreQueryPrefix: true
  });
  const pageHref =
    location.pathname +
    qs.stringify(
      Object.assign(Object.assign({}, currentLocation), {
        [queryParam]: page
      }),
      { addQueryPrefix: true, encodeValuesOnly: true, skipNulls: true }
    );
  return (
    <StyledLink
      to={pageHref}
      style={
        isCurrent && {
          background: '#dadada',
          pointerEvents: 'none'
        }
      }
      onClick={e => handleClick(e, goToPage, page)}
      aria-label={
        isCurrent ? `Current Page, Goto Page ${page}` : `Goto Page ${page}`
      }
      aria-current={isCurrent}
    >
      {page}
    </StyledLink>
  );
};
export default withRouter(PageLink);
